import { css } from "@emotion/react"
import { colors } from "source/shared/colors"
import { LegacyHeading } from "./LegacyHeading"
import { Icon } from "./Icon"
import { NarrowLayout } from "source/Layout"
import { useSession } from "source/shared/hooks/useSession"
import { Link, useLocation } from "react-router"

export function Error403() {
  const {
    meta: { authenticated },
  } = useSession(false)
  const { pathname, search } = useLocation()

  const loginUrl = `/login?return=${pathname + search}`

  return (
    <NarrowLayout>
      <div className="ta-c">
        <div css={styles.iconCircleBackground}>
          <div css={styles.icon}>
            <Icon symbol="general#lock" aria-label="forbidden" />
          </div>
        </div>
        <LegacyHeading level={1} text="You don't have access" />
        {!authenticated && (
          <p className="mt-1">
            Do you need to <Link to={loginUrl}>log in</Link>?
          </p>
        )}
      </div>
    </NarrowLayout>
  )
}

const styles = {
  iconCircleBackground: css`
    background-image: linear-gradient(
      135deg,
      ${colors.brandGradientStart} 0%,
      ${colors.brandGradientEnd} 100%
    );
    border-radius: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 64px;
    margin-bottom: 1.5rem;
    position: relative;
    text-align: center;
    width: 64px;

    &:before {
      background-color: white;
      border-radius: 100%;
      content: "";
      height: 58px;
      left: 3px;
      position: absolute;
      top: 3px;
      width: 58px;
    }
  `,
  icon: css`
    color: ${colors.brand};
    font-size: 32px;
    position: relative;
  `,
}
